import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import companyInfosServices from '@src/services/companyInfos.services';
import invoiceAddressServices from '@src/services/InvoiceAddresses.services';

export const getCompanyList = createAsyncThunk(
  'getList',
  async (_, { getState, rejectWithValue }) => {
    try {
      const customerId = await getState()?.customer?.selectedCustomer?.customerId;

      const result = await invoiceAddressServices.invoiceAddressGetList(customerId);
      return result;
    } catch (err) {
      return rejectWithValue(err.data);
    }
  },
);

export const updateCompanyInfos = createAsyncThunk(
  'updateCompanyInfos',
  async (body, { getState, rejectWithValue }) => {
    try {
      const customerId = await getState()?.customer?.selectedCustomer?.customerId;

      const result = await invoiceAddressServices.invoiceAddressUpdate({
        ...body,
        customerId: customerId,
      });
      return result;
    } catch (err) {
      return rejectWithValue(err.data);
    }
  },
);

export const addCompanyInfoFiles = createAsyncThunk(
  'addCompanyInfoFiles',
  async (data, { rejectWithValue }) => {
    try {
      const result = await companyInfosServices.addCompanyInfoFiles(data);
      return result;
    } catch (err) {
      return rejectWithValue(err.data);
    }
  },
);

const initialState = {
  companyInfoList: [],
  response: {},
};

export const companyInfosSlice = createSlice({
  name: 'companyInfos',
  initialState,
  reducers: {
    resetResponse: (state) => {
      state.response = {};
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getCompanyList.fulfilled, (state, action) => {
      state.companyInfoList = action?.payload?.data;
      state.response = {};
    });
    builder.addCase(updateCompanyInfos.fulfilled, (state, action) => {
      state.response = {
        success: action?.payload?.isSuccess,
        message: action?.payload?.error?.message,
      };
    });
    builder.addCase(updateCompanyInfos.rejected, (state, action) => {
      state.response = {
        success: action?.payload?.isSuccess,
        message: action?.payload?.error?.message,
      };
    });
    builder.addCase(addCompanyInfoFiles.fulfilled, (state, action) => {
      state.response = {
        success: true,
        message: action?.payload?.error?.message,
      };
    });
    builder.addCase(addCompanyInfoFiles.rejected, (state, action) => {
      state.response = {
        success: false,
        message: action?.payload?.error?.message,
      };
    });
  },
});

export const { resetResponse } = companyInfosSlice.actions;
